/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_Media_Not_FoundInputs */

const en_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media file not found. Please re-import media.`)
};

const fr_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier média introuvable. Veuillez réimporter le média.`)
};

const de_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mediendatei nicht gefunden. Bitte importieren Sie die Mediendatei erneut.`)
};

const it_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File multimediale non trovato. Reimporta il file multimediale.`)
};

const ru_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медиафайл не найден. Пожалуйста, импортируйте медиафайл повторно.`)
};

const es_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró el archivo multimedia. Vuelva a importarlo.`)
};

const zh_cn2_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到媒体文件。请重新导入媒体文件。`)
};

const ja_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアファイルが見つかりません。メディアを再インポートしてください。`)
};

const hi_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया फ़ाइल नहीं मिली। कृपया मीडिया को पुनः आयात करें।`)
};

const pt_pt2_team_project_import_media_not_found = /** @type {(inputs: Team_Project_Import_Media_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo de mídia não encontrado. Por favor, importe a mídia novamente.`)
};

/**
* | output |
* | --- |
* | "Media file not found. Please re-import media." |
*
* @param {Team_Project_Import_Media_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_media_not_found = /** @type {((inputs?: Team_Project_Import_Media_Not_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_Media_Not_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_project_import_media_not_found(inputs)
	if (locale === "de") return de_team_project_import_media_not_found(inputs)
	if (locale === "it") return it_team_project_import_media_not_found(inputs)
	if (locale === "ru") return ru_team_project_import_media_not_found(inputs)
	if (locale === "es") return es_team_project_import_media_not_found(inputs)
	if (locale === "zh-CN") return zh_cn2_team_project_import_media_not_found(inputs)
	if (locale === "ja") return ja_team_project_import_media_not_found(inputs)
	if (locale === "hi") return hi_team_project_import_media_not_found(inputs)
	if (locale === "pt-PT") return pt_pt2_team_project_import_media_not_found(inputs)
	return en_team_project_import_media_not_found(inputs)
});